import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

/** The title block every screen opens with. */
export function ScreenHead({ eyebrow, title, aside }) {
    const reduced = useReducedMotion();

    return (
        <motion.div
            className="screen__head"
            initial={reduced ? false : { opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: EASE }}
        >
            <div>
                <span className="screen__eyebrow">{eyebrow}</span>
                <h2 className="screen__title">{title}</h2>
            </div>
            {aside}
        </motion.div>
    );
}

/**
 * One item in a screen's content, rising in after the heading.
 *
 * The delay is capped: a screen with eighteen menu items would otherwise
 * spend two seconds finishing its entrance, and the reader is already
 * looking at it.
 */
export function Rise({ index = 0, children, className, ...rest }) {
    const reduced = useReducedMotion();

    return (
        <motion.div
            className={className}
            initial={reduced ? false : { opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65, delay: Math.min(0.1 + index * 0.05, 0.6), ease: EASE }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}
